import React, { Component } from 'react'
import { withStyles, Card, CardHeader, Avatar, Typography, CardContent, Grid, TextField, FormControl, InputLabel, Select, OutlinedInput, MenuItem, CardActions, Button } from '@material-ui/core';
import Add from '@material-ui/icons/Add'
import Rich from './Rich';
import Snack from '../../Snackbar/Snack';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { GetData, DeleteData, PutData } from '../../../api/service';

const styles = theme => ({
    textField: {
        width: '100%'
    },
    formControl: {
        width: '100%',
        marginTop: theme.spacing.unit * 2
    }
})

class EditNewCo extends Component {

    state = {
        id: '',
        dept_code: '',
        program_outcome: '',
        program_specific_outcome: '',
        course_outcome: '',
        departments: [],
        isLoaded: true,
        open: false,
        message: '',
        edit: false
    }

    __loadData() {
        let data = this.props.history.location.state;
        //console.log(data)
        this.setState({
            ...data,
            edit: true,

        })
    }

    componentDidMount() {
        // load edit data

        GetData(`/getdepartments`)
            .then((resp) => {
                this.setState({
                    departments: resp,
                    isLoaded: true
                }, () => this.__loadData())
            })


    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.__loadData()
        }
    }


    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleRichChange = (name,data) => {
        this.setState({
            [name]: data
        })
    }

    onSetFile = (data) => {
        //console.log(data)
        this.setState({
            uploadInfo: data
        })
    }

    onSubmit = (e) => {
        e.preventDefault();

        let data = {
            ...this.state
        }

        //console.log(data);


        PutData(`/${this.props.apikey}/${this.state.id}/editcourse`, data)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    open: true,
                    message: resp
                })
            })

    }

    deleteNotice = () => {
        let id = this.state.id;

        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.confirmDeleteNotice(id)
                },
                {
                    label: 'No'
                }
            ]
        })

    }

    confirmDeleteNotice = (id) => {
        DeleteData(`/${this.props.apikey}/${id}/deletecourse`)
            .then((resp) => {
                console.log(resp)
                this.setState({
                    open: true,
                    message: resp
                })
            }).then(() => {
                this.props.history.replace('/')
            })
    }

    render() {
        let { classes } = this.props;
        return (
            <div>

                {this.state.open ?
                    <Snack
                        open={this.state.open}
                        handleClose={() => {
                            this.setState({
                                open: false,
                                message: ''
                            })
                        }}
                        message={this.state.message}
                    />

                    : null}
                <form onSubmit={this.onSubmit}>
                    <Card>
                        <CardHeader
                            avatar={
                                <Avatar>
                                    <Add />
                                </Avatar>
                            }
                            title={
                                <Typography
                                    variant="h6"
                                >
                                    Edit Course &amp; Program Outcome
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Grid container spacing={24}>
                                <Grid item lg={12} sm={12}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel >
                                            Department Code
                    </InputLabel>
                                        <Select
                                            value={this.state.dept_code}
                                            onChange={this.handleChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="posted_as" />
                                            }
                                            required={true}
                                            name="dept_code"

                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {this.state.departments.map((el, index) =>
                                                <MenuItem key={index} value={el.web_dept_code}>{el.dept_name}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item lg={12} sm={12}>
                                    <Typography
                                        variant="h6"
                                    >
                                        Program Outcomes
                  </Typography>
                                    {this.state.edit ? (
                                        <Rich
                                            placeholder="Description....."
                                            onChange={this.handleRichChange.bind(this, 'program_outcome')}
                                            edit={this.state.program_outcome}
                                        />
                                    ) : null}
                                </Grid>

                                <Grid item lg={12} sm={12}>
                                    <Typography
                                        variant="h6"
                                    >
                                        Program Specific Outcomes
                  </Typography>
                                    {this.state.edit ? (
                                        <Rich
                                            placeholder="Description....."
                                            onChange={this.handleRichChange.bind(this, 'program_specific_outcome')}
                                            edit={this.state.program_specific_outcome}
                                        />
                                    ) : null}
                                </Grid>

                                <Grid item lg={12} sm={12}>
                                    <Typography
                                        variant="h6"
                                    >
                                        Course Outcomes
                  </Typography>
                                    {this.state.edit ? (
                                        <Rich
                                            placeholder="Description....."
                                            onChange={this.handleRichChange.bind(this, 'course_outcome')}
                                            edit={this.state.course_outcome}
                                        />
                                    ) : null}
                                </Grid>
                            </Grid>
                        </CardContent>

                        <CardActions>
                            <Button
                                variant="outlined"
                                color="primary"
                                type="submit"
                            >
                                Update
            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                type="button"
                                onClick={this.deleteNotice}
                            >
                                Delete
            </Button>
                        </CardActions>

                    </Card>

                </form>

            </div>
        )
    }
}

export default withStyles(styles)(EditNewCo)


// WEBPACK FOOTER //
// ./src/Components/Department/CO/EditNewCo.js